<template>
  <div>
    File View
    <iframe :src="filepath" width="100%" height="600"></iframe>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  data() {
    return {
      userfile: {}
    };
  },
  computed: {
    filepath() {
      return process.env.VUE_APP_FILE_BASE + this.userfile.full_url;
    }
  },
  mounted() {
    this.$http.get("userfiles/" + this.$route.params.id).then(
      response => {
        this.userfile = response.data.data;
      },
      response => {
        console.log("Error pulling userfile.");
      }
    );
  }
};
</script>
